import { useContext } from "react";
import { SocketContext } from "../context/SocketProvider";
import { DEFAULT_ROOM } from "../constants/gameStages";

/**
 * Custom hook to manage game stage updates.
 * It provides a function to update the game stage via the socket connection.
 * @returns {Object} An object containing the updateStage function.
 * */
export const useGameStage = () => {
  const { socket } = useContext(SocketContext);

  const updateStage = (stage, room = DEFAULT_ROOM) => {
    socket.emit("update_game_stage", { room, stage });
  };

  return { updateStage };
};
